import { Component } from "@angular/core";
import { AppCardComponent } from "../../../../Common/Components/Card/CardComponent";
import { PageHeaderComponent } from "../../../../Common/Components/PageHeader/PageHeaderComponent";

@Component({
  standalone: true,
  selector: "app-reset-password-page",
  imports: [AppCardComponent, PageHeaderComponent],
  templateUrl: "./ResetPasswordPage.html",
  styleUrl: "./ResetPasswordPage.scss",
})
export class ResetPasswordPage {}
